import { render, staticRenderFns } from "./CoaterEdit.vue?vue&type=template&id=4ad22030&"
import script from "./CoaterEdit.vue?vue&type=script&lang=ts&"
export * from "./CoaterEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports